import { Link } from "react-router-dom";

const entries = [
  {
    type: "movie",
    label: "电影",
    en: "MOVIES",
    desc: "午夜长片，一场完整的情绪旅程",
    count: "10 部精选",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20cinema%20hall%20seats%20at%20midnight%20with%20a%20glowing%20orange%20screen%20edge%2C%20stylized%20artistic%20moody%20atmosphere%2C%20deep%20navy%20blue%20tones%20with%20warm%20accents%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=700&height=900&seq=midnight-cat-movie&orientation=portrait",
  },
  {
    type: "tv",
    label: "电视剧",
    en: "TV SERIES",
    desc: "深夜追更，一集接一集停不下来",
    count: "9 部剧集",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20living%20room%20at%20night%20with%20a%20tv%20casting%20a%20warm%20orange%20glow%20on%20the%20wall%2C%20stylized%20artistic%20moody%20atmosphere%2C%20deep%20navy%20blue%20tones%20with%20warm%20accents%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=700&height=900&seq=midnight-cat-tv&orientation=portrait",
  },
  {
    type: "variety",
    label: "综艺",
    en: "VARIETY",
    desc: "轻松下饭，午夜时分的陪伴感",
    count: "5 档节目",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20stage%20with%20microphone%20and%20warm%20spotlights%20in%20a%20dark%20studio%20at%20night%2C%20stylized%20artistic%20moody%20atmosphere%2C%20deep%20navy%20blue%20tones%20with%20warm%20accents%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=700&height=900&seq=midnight-cat-variety&orientation=portrait",
  },
];

export default function CategoryEntries() {
  return (
    <section className="mx-auto max-w-page px-4 md:px-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {entries.map((entry) => (
          <Link
            key={entry.type}
            to={`/category?type=${entry.type}`}
            className="group relative block h-56 md:h-72 rounded-lg overflow-hidden border border-background-300/60 transition-colors hover:border-primary-500/60 cursor-pointer"
          >
            <img
              src={entry.image}
              alt={`${entry.label} 分类入口`}
              title={`${entry.label} - 午夜免费视频`}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/50 to-transparent"></div>
            <div className="absolute inset-0 p-5 md:p-6 flex flex-col justify-end">
              <span className="text-[11px] font-label tracking-[0.28em] text-primary-300">{entry.en}</span>
              <div className="mt-1 flex items-center justify-between">
                <h3 className="font-heading font-extrabold text-2xl text-foreground-950">{entry.label}</h3>
                <span className="w-9 h-9 rounded-full bg-primary-500/15 border border-primary-500/40 text-primary-300 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
              <p className="mt-1.5 text-sm text-foreground-600">{entry.desc}</p>
              <span className="mt-2 text-xs text-foreground-500 font-label">{entry.count}</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}